import { useEffect } from 'react'
import { SEOHead } from '@/components/seo-head'
import { createSoftwareAppStructuredData, SOURCEDIN_SOFTWARE_DATA } from '@/components/structured-data/software-app'
import { logValidationResults, generateRichResultsTestUrl } from '@/components/structured-data/validation'

export function StructuredDataTest() {
  const softwareAppData = createSoftwareAppStructuredData(SOURCEDIN_SOFTWARE_DATA)

  useEffect(() => {
    // Log validation results to console
    logValidationResults()
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <SEOHead
        title="Structured Data Test - SourcedIn"
        description="Test page for validating SoftwareApplication structured data"
        structuredData={softwareAppData}
      />
      
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">
          Structured Data Test Page
        </h1>
        
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            SoftwareApplication Structured Data
          </h2>
          <p className="text-gray-600 mb-4">
            This page contains the SoftwareApplication structured data for SourcedIn.
            Check the browser console for validation results.
          </p>
          
          <div className="bg-gray-100 rounded-lg p-4 mb-4">
            <h3 className="font-medium text-gray-900 mb-2">Validation Test URL:</h3>
            <a 
              href={generateRichResultsTestUrl(window.location.href)}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline break-all"
            >
              {generateRichResultsTestUrl(window.location.href)}
            </a>
          </div>
          
          <div className="bg-gray-100 rounded-lg p-4">
            <h3 className="font-medium text-gray-900 mb-2">Generated Structured Data:</h3>
            <pre className="text-sm text-gray-700 overflow-auto">
              {JSON.stringify(softwareAppData, null, 2)}
            </pre>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Implementation Details
          </h2>
          <div className="space-y-3 text-gray-600">
            <p>
              <strong>Application Category:</strong> {SOURCEDIN_SOFTWARE_DATA.applicationCategory}
            </p>
            <p>
              <strong>Operating Systems:</strong> {SOURCEDIN_SOFTWARE_DATA.operatingSystem.join(', ')}
            </p>
            <p>
              <strong>Price:</strong> ${SOURCEDIN_SOFTWARE_DATA.offers.price} {SOURCEDIN_SOFTWARE_DATA.offers.priceCurrency}
            </p>
            <p>
              <strong>Rating:</strong> {SOURCEDIN_SOFTWARE_DATA.aggregateRating?.ratingValue}/5 ({SOURCEDIN_SOFTWARE_DATA.aggregateRating?.reviewCount} reviews)
            </p>
            <p>
              <strong>Version:</strong> {SOURCEDIN_SOFTWARE_DATA.softwareVersion}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
